import client from "./client";

export const ragApi = {
  status:  ()         => client.get("/rag/status"),
  list:    ()         => client.get("/rag/documents"),
  delete:  (id)       => client.delete(`/rag/documents/${id}`),
  reindex: (id)       => client.post(`/rag/documents/${id}/reindex`),
  chunks:  (id)       => client.get(`/rag/documents/${id}/chunks`),

  search: (q, k = 5, machineTypeId = null) =>
    client.get("/rag/documents/search", {
      params: { q, k, ...(machineTypeId ? { machine_type_id: machineTypeId } : {}) },
    }),

  upload: (file, category, description, machineTypeId = null, projectId = null) => {
    const form = new FormData();
    form.append("file", file);
    form.append("category", category);
    form.append("description", description);
    if (machineTypeId) form.append("machine_type_id", machineTypeId);
    if (projectId)     form.append("project_id",      projectId);
    return client.post("/rag/documents", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
